// APP ACTION TYPES
export const APP_PAGE_LOADED = "APP_PAGE_LOADED";
export const APP_SET_IS_GA_TRANSACTION_TRACKED = "APP_SET_IS_GA_TRANSACTION_TRACKED";

// GENERAL ACTION TYPES
export const GENERAL_CLEAR_FLASH = "GENERAL_CLEAR_FLASH";
export const GENERAL_SET_FLASH = "GENERAL_SET_FLASH";
export const GENERAL_SHOW_GLOBAL_MODAL = "GENERAL_SHOW_GLOBAL_MODAL";

// CONFIG ACTION TYPES
export const CONFIG_INITIALIZE_CONFIG = "CONFIG_INITIALIZE_CONFIG";
export const CONFIG_SET_APPEARANCE = "CONFIG_SET_APPEARANCE";
export const CONFIG_SET_SYSTEM_APPEARANCE = "CONFIG_SET_SYSTEM_APPEARANCE";
